module.exports = __webpack_public_path__ + "media/images/ntt-dynamic-loop-logo-d792d5fdc67657d08b339a448e38a9e7.png";